export default `
§ page.showcase.title: Список отчётов
§ page.showcase.table.code: Код
§ page.showcase.table.title: Название
§ page.showcase.table.description: Описание
`;
